/* ============================================================
   CRINÉOL — Interactions de la page
   L'ajout au panier est géré par crineol-cart.js (tiroir panier).
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* 1. Compte a rebours persistant */
  function countdown() {
    var els = $$('[data-countdown]');
    if (!els.length) return;
    var KEY = 'crineol_cd';
    var span = 4 * 60 * 60 * 1000;
    var end;
    try { end = parseInt(localStorage.getItem(KEY), 10); } catch (e) { end = 0; }
    if (!end || isNaN(end) || end < Date.now()) {
      end = Date.now() + span;
      try { localStorage.setItem(KEY, String(end)); } catch (e) {}
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function tick() {
      var d = Math.max(0, end - Date.now());
      var h = Math.floor(d / 3.6e6), m = Math.floor(d % 3.6e6 / 6e4), s = Math.floor(d % 6e4 / 1000);
      els.forEach(function (el) {
        var H = $('[data-h]', el), M = $('[data-m]', el), S = $('[data-s]', el);
        if (H) H.textContent = pad(h);
        if (M) M.textContent = pad(m);
        if (S) S.textContent = pad(s);
      });
    }
    tick(); setInterval(tick, 1000);
  }

  /* 2. Galerie produit */
  function gallery() {
    var g = $('[data-gallery]');
    if (!g) return;
    var imgs = $$('.gal-main img', g), thumbs = $$('.gal-thumbs button', g), i = 0;
    if (!imgs.length) return;
    function go(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('on', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      var t = thumbs[i];
      if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = $('.gal-prev', g), n = $('.gal-next', g);
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (n) n.addEventListener('click', function () { go(i + 1); });
    var x0 = null, main = $('.gal-main', g);
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(dx < 0 ? i + 1 : i - 1);
        x0 = null;
      }, { passive: true });
    }
    go(0);
  }

  /* 3. Selecteur de bundles */
  function bundles() {
    var form = $('[data-buy-form]');
    if (!form) return;
    var cards = $$('.bundle', form);
    var stickyName = $('[data-sticky-name]'), stickyPrice = $('[data-sticky-price]');
    var btnLabels = $$('[data-cart-price]');

    function select(card) {
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('on', on);
        var inp = $('input', c);
        if (inp) inp.checked = on;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var price = card.getAttribute('data-price');
      var name = card.getAttribute('data-name');
      btnLabels.forEach(function (b) { b.textContent = price; });
      if (stickyName) stickyName.textContent = name;
      if (stickyPrice) stickyPrice.textContent = price;
      form.setAttribute('data-variant', card.getAttribute('data-variant'));
    }

    cards.forEach(function (c) {
      c.addEventListener('click', function () { select(c); });
      c.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(c); }
      });
    });
    var pre = $('.bundle.on', form) || cards[1] || cards[0];
    if (pre) select(pre);
  }

  /* 4. Barre ATC collante */
  function stickyBar() {
    var bar = $('.sticky-atc'), anchor = $('[data-buy-form]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* 5. Carrousels */
  function rails() {
    $$('[data-rail]').forEach(function (wrap) {
      var rail = $('.rail', wrap);
      if (!rail) return;
      var bar = $('.rail-bar i', wrap);
      var prev = $('[data-rail-prev]', wrap), next = $('[data-rail-next]', wrap);
      function step() { return Math.max(200, rail.clientWidth * 0.8); }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      function upd() {
        if (!bar) return;
        var ratio = rail.clientWidth / rail.scrollWidth;
        var max = rail.scrollWidth - rail.clientWidth;
        var p = max > 0 ? rail.scrollLeft / max : 0;
        var w = Math.max(12, ratio * 100);
        bar.style.width = w + '%';
        bar.style.transform = 'translateX(' + (p * (100 / (w / 100) - 100)) + '%)';
      }
      rail.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* 6. Revelation au scroll */
  function reveal() {
    var els = $$('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); }); return;
    }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 7. Avis : voir plus */
  function moreReviews() {
    var btn = $('[data-rev-more]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      $$('.rev-item[hidden]').slice(0, 6).forEach(function (el) { el.removeAttribute('hidden'); });
      if (!$('.rev-item[hidden]')) btn.remove();
    });
  }

  /* 8. Accordeons exclusifs */
  function exclusiveAcc() {
    $$('[data-acc-group]').forEach(function (group) {
      var items = $$('details', group);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* 9. Ancres douces */
  function smooth() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' });
    });
  }

  function init() {
    countdown(); gallery(); bundles(); stickyBar();
    rails(); reveal(); moreReviews(); exclusiveAcc(); smooth();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
